export const soupData = [
  {
    id: 1,
    type: '日式',
    name: '相撲鍋湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot01',
    soup: 'soup01',
    intro: '充分融合雞湯的甘美與豬大骨湯的醇厚，並加入柴魚及昆布提鮮，無論是燉煮蔬菜或肉類合宜。',
    tags: [{ text: '風味淡雅' }, { text: '甘甜' }],
    link: 'https://shop.muji.tw/SalePage/Index/8917557',
  },
  {
    id: 2,
    type: '日式',
    name: '壽喜燒湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot02',
    soup: 'soup02',
    intro: '以醬油為基底加入味醂、柴魚精華調味，充分釋放香醇醬香與酒香，適合煨煮肉類或烏龍麵品嚐。',
    tags: [{ text: '香醇醬香與酒香' }, { text: '濃且鹹' }],
    link: 'https://shop.muji.tw/SalePage/Index/8917554',
  },
  {
    id: 3,
    type: '日式',
    name: '蘿蔔泥醬露湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot03',
    soup: 'soup03',
    intro: '將醬油與雪花般的蘿蔔泥添加於湯中調煮，可感受蘿蔔泥顆粒口感及鮮甜感，適合煮食豬肉與蔬菜的清爽湯品。',
    tags: [
      {
        text: '清爽鮮甜',
      },
      {
        text: '雪鍋',
      },
      {
        text: '雪見鍋',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917555',
  },
  {
    id: 4,
    type: '日式',
    name: '辣味柚香雞湯底',
    flag: 'jp.svg',
    hotpot: 'hotpot05',
    soup: 'soup05',
    intro: '甘醇雞骨高湯結合酸甜葡萄柚汁，加入辣椒粉提出辛香層次，風味清爽的開胃湯品。',
    tags: [
      {
        text: '酸香風味',
      },
      {
        text: '清爽開胃',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917556',
  },
  {
    id: 5,
    type: '台式',
    name: '蔥香鴨骨湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot04',
    soup: 'soup04',
    intro: '將鴨骨與青蔥煎炒產生濃郁香氣後，加入醬油及味醂，與鴨骨精華充分結合，可搭配麵及蔬菜一同品嚐。',
    tags: [
      {
        text: '風味清爽',
      },
      {
        text: '溫順不膩口',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917560',
  },
  {
    id: 6,
    type: '台式',
    name: '剝皮辣椒湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot06',
    soup: 'soup06',
    intro: '剝皮辣椒切得細碎後入湯熬煮，帶出高湯的微辣甘甜，一款台灣家常的溫補湯品。',
    tags: [
      {
        text: '風味微辣回甘',
      },
      {
        text: '椒香暖胃',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917558',
  },
  {
    id: 7,
    type: '台式',
    name: '麻油雞湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot07',
    soup: 'soup07',
    intro: '麻油與薑片煸炒出香氣後添加適量米酒及冰糖提出甜感，一款台灣家常的溫補湯品。',
    tags: [
      {
        color: '#7F0019',
        text: '冬季限定販售',
      },
      {
        text: '溫潤香醇',
      },
      {
        text: '薑香暖身',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917577',
  },
  {
    id: 8,
    type: '台式',
    name: '薑母鴨湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot08',
    soup: 'soup08',
    intro: '爆炒薑片與麻油釋放出焦香後加入鴨骨高湯及米酒一同燉煮入味，一款適合於冬季的禦寒湯品。 ',
    tags: [
      {
        color: '#7F0019',
        text: '冬季限定販售',
      },
      {
        text: '薑香濃郁',
      },
      {
        text: '薑暖驅寒',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917594',
  },
  {
    id: 9,
    type: '台式',
    name: '藥燉排骨湯底',
    flag: 'tw.svg',
    hotpot: 'hotpot09',
    soup: 'soup09',
    intro: '添加當歸、枸杞、甘草等多種中藥材，熬出甘醇濃郁香氣，一款隨時可享用的溫暖湯品。',
    tags: [
      {
        color: '#7F0019',
        text: '冬季限定販售',
      },
      {
        text: '藥香甘醇',
      },
      {
        text: '溫補暖身',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917575',
  },
  {
    id: 10,
    type: '韓式',
    name: '雪濃牛骨湯底',
    flag: 'kr.svg',
    hotpot: 'hotpot10',
    soup: 'soup10',
    intro: '韓國傳統祭祀先農祭時飲用的湯品，以大骨慢熬成乳白湯色，搭配薑蒜提味，適合搭配米麵食的濃郁湯品。',
    tags: [
      {
        text: '口味濃厚不膩口',
      },
      {
        text: '鮮甜回甘',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/8917550',
  },
  {
    id: 11,
    type: '港式',
    name: '胡椒豬肚湯底',
    flag: 'hk.svg',
    hotpot: 'hotpot11',
    soup: 'soup11',
    intro: '豬骨湯底加入辛香料和米酒熬煮，醇厚湯頭散發微嗆白胡椒辛香，經典的港式煲湯湯底。',
    tags: [
      {
        text: '胡椒辛香',
      },
      {
        text: '溫潤濃郁',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/10653137',
  },
  {
    id: 12,
    type: '港式',
    name: '椰子雞湯底',
    flag: 'hk.svg',
    hotpot: 'hotpot12',
    soup: 'soup12',
    intro: '雞湯加入多種藥材一起熬煮，氣味清香清甜、溫潤滋補，經典的港式煲湯湯底。',
    tags: [
      {
        text: '清香甘甜',
      },
      {
        text: '溫潤滋補',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/10653138',
  },
  // {
  //   id: 13,
  //   type: '港式',
  //   name: '沙嗲湯底',
  //   flag: 'hk.svg',
  //   hotpot: 'hotpot14',
  //   soup: 'soup12',
  //   intro: '雞湯加入多種藥材一起熬煮，氣味清香清甜、溫潤滋補，經典的港式煲湯湯底。',
  //   tags: [
  //     {
  //       text: '清香甘甜',
  //     },
  //     {
  //       text: '溫潤滋補',
  //     },
  //   ],
  //   link: 'https://shop.muji.tw/',
  // },
  {
    id: 14,
    type: '泰式',
    name: '泰式酸辣湯底',
    flag: 'th.svg',
    hotpot: 'hotpot13',
    soup: 'soup13',
    intro: '各式香草平衡辣椒與魚露味道，酸中帶辣、散發獨有辛香，適合加入海鮮一起品嚐的泰式湯底。',
    tags: [
      {
        text: '酸中帶辣',
      },
      {
        text: '清爽不膩',
      },
    ],
    link: 'https://shop.muji.tw/SalePage/Index/10653139',
  },
];

export const reportData = [
  {
    id: 1,
    link: 'https://www.muji.tw/tw/feature/soup/',
    img: 'special01.jpg',
    text: '無印良品的火鍋湯底',
  },
  {
    id: 2,
    link: 'https://www.muji.tw/tw/curry/',
    img: 'special02.jpg',
    text: '無印良品的異國咖哩',
  },
  {
    id: 3,
    link: 'https://www.muji.tw/tw/feature/24aw/pasta/',
    img: 'special03.jpg',
    text: '無印良品的義大利麵與義大利麵醬',
  },
  {
    id: 4,
    link: 'https://shop.muji.tw/sb/style/',
    img: 'special04.jpg',
    text: '創意料理',
  },
  {
    id: 5,
    link: 'https://www.muji.tw/tw/feature/frozen-foods/',
    img: 'special05.jpg',
    text: '冷凍食品',
  },
  {
    id: 6,
    link: 'https://www.muji.tw/tw/muji-market-golden/',
    img: 'special06.jpg',
    text: '黃金廊道',
  },
];
